import React, { Component } from 'react';

import './Css/spinner.css'

type Props = {
    show: boolean;
}

export class FstyrSpinner extends Component<Props> {

    render() {
        return (
            this.props.show
            &&
            <div className="ldio-oz728wu23i-container">
                <div className="loadingio-spinner-spin-0xu2y23zeqmr">
                    <div className="ldio-oz728wu23i">
                        {/* Div that holds all the dots in the spinner */}
                        <div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div><div><div></div></div>
                    </div>
                </div>
            </div>
        );
    }
}
